var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_1205)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00024 12C10.2094 12 12.0002 10.2091 12.0002 8C12.0002 5.79086 10.2094 4 8.00024 4C5.79111 4 4.00024 5.79086 4.00024 8C4.00024 10.2091 5.79111 12 8.00024 12ZM8.00024 10C9.10481 10 10.0002 9.10457 10.0002 8C10.0002 6.89543 9.10481 6 8.00024 6C6.89567 6 6.00024 6.89543 6.00024 8C6.00024 9.10457 6.89567 10 8.00024 10Z",
    fill: "#97A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42685 16.8138C3.5513 17.2951 3.09646 17.8737 2.94895 18.3162C2.77431 18.8402 2.20799 19.1233 1.68404 18.9487C1.1601 18.774 0.87694 18.2077 1.05159 17.6838C1.40408 16.6263 2.29239 15.7049 3.46341 15.0612C4.65089 14.4084 6.195 14 8.00027 14C9.80554 14 11.3496 14.4084 12.5371 15.0612C13.7081 15.7049 14.5965 16.6263 14.949 17.6838C15.1236 18.2077 14.8404 18.774 14.3165 18.9487C13.7926 19.1233 13.2262 18.8402 13.0516 18.3162C12.9041 17.8737 12.4492 17.2951 11.5737 16.8138C10.7146 16.3416 9.50871 16 8.00027 16C6.49183 16 5.28594 16.3416 4.42685 16.8138Z",
    fill: "#97A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 5C15.0002 4.44771 15.448 4 16.0002 4H22.0002C22.5525 4 23.0002 4.44771 23.0002 5C23.0002 5.55229 22.5525 6 22.0002 6H16.0002C15.448 6 15.0002 5.55229 15.0002 5Z",
    fill: "#97A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 8C15.448 8 15.0002 8.44771 15.0002 9C15.0002 9.55229 15.448 10 16.0002 10H22.0002C22.5525 10 23.0002 9.55229 23.0002 9C23.0002 8.44771 22.5525 8 22.0002 8H16.0002Z",
    fill: "#97A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 13C15.0002 12.4477 15.448 12 16.0002 12H22.0002C22.5525 12 23.0002 12.4477 23.0002 13C23.0002 13.5523 22.5525 14 22.0002 14H16.0002C15.448 14 15.0002 13.5523 15.0002 13Z",
    fill: "#97A0A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_1205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/ContactInfo.d5d668807630dcc9243e562b8ddcc71f.svg";
export { ForwardRef as ReactComponent };